"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cloneValue_1 = __importDefault(require("./cloneValue"));
// returns new object for each parent for the path given with the leaf reference changed
function setChild(parent, path, value) {
    var leaf = parent;
    for (var i = 0; i < path.length; i += 1) {
        var part = path[i];
        if (typeof leaf !== 'object' || leaf === null) {
            break;
        }
        if (Array.isArray(leaf)) {
            leaf = leaf[+part];
        }
        else {
            leaf = leaf[part];
        }
    }
    if (leaf === value) {
        return parent;
    }
    if (!path.length) {
        return value;
    }
    var newParent = (0, cloneValue_1.default)(parent);
    leaf = newParent;
    for (var i = 0; i < path.length - 1; i += 1) {
        if (typeof leaf !== 'object' || leaf === null) {
            leaf = {};
        }
        else {
            leaf = __assign({}, leaf);
        }
        if (Array.isArray(leaf)) {
            leaf = leaf[+path[i]];
        }
        else {
            leaf = leaf[path[i]];
        }
    }
    if (typeof leaf !== 'object' || leaf === null) {
        leaf = {};
    }
    var lastKey = path[path.length - 1];
    if (Array.isArray(leaf)) {
        leaf[+lastKey] = value;
    }
    else {
        leaf[lastKey] = value;
    }
    return newParent;
}
exports.default = setChild;
